import { countryCodes, unitedStatesTerritories } from '@tunein/web-common';
import { Singleton } from '@tunein/web-utils';
import { noop } from 'es-toolkit';
import { PARTNER_ADS_CONFIG } from '../constants';
import { debug } from '../utils';
const PARTNER_ALIAS_PLACEHOLDER = '{partnerAlias}';
class ApiSingleton extends Singleton {
    // TODO: consider moving this to Api Client. We could potentially group location data helpers in an API like
    //  `api.geo.isInUs`, but until we have more real use cases, we shouldn't eagerly pollute WAC.
    get isInUS() {
        const countryCode = this.instance.locationData?.country_code;
        return Boolean(countryCode === countryCodes.US ||
            unitedStatesTerritories[countryCode]);
    }
    init(instance) {
        return instance;
    }
    logError(message, context = {}, printDebugLog = true) {
        if (printDebugLog) {
            debug(message, context);
        }
        return this.instance.telemetry.logError({ message, context }).catch(noop);
    }
    getAdUnitConfig(clientType, medium) {
        const adConfig = this.instance.getConfigSetting(PARTNER_ADS_CONFIG);
        const adUnitConfig = adConfig?.[clientType]?.[medium];
        if (!adUnitConfig) {
            return;
        }
        const adUnitId = adUnitConfig.adUnitId?.replace(PARTNER_ALIAS_PLACEHOLDER, this.instance.adsTargeting.ads_partner_alias || '');
        return {
            ...adUnitConfig,
            adUnitId,
        };
    }
}
export const api = new ApiSingleton();
export function getExperiment(key, fallback) {
    return api.getConfigSetting(key, fallback);
}
